export interface CountryData {
  name: string;
  code: string;
  code3: string;
  numCode: string;
}

export interface StateData {
  name: string;
  stateCode: string;
  countryCode: string;
}

export const countries: CountryData[] = [
  { name: "Afghanistan", code: "AF", code3: "AFG", numCode: "004" },
  { name: "Åland Islands", code: "AX", code3: "ALA", numCode: "248" },
  { name: "Albania", code: "AL", code3: "ALB", numCode: "008" },
  { name: "Algeria", code: "DZ", code3: "DZA", numCode: "012" },
  { name: "American Samoa", code: "AS", code3: "ASM", numCode: "016" },
  { name: "Andorra", code: "AD", code3: "AND", numCode: "020" },
  { name: "Angola", code: "AO", code3: "AGO", numCode: "024" },
  { name: "Anguilla", code: "AI", code3: "AIA", numCode: "660" },
  { name: "Antarctica", code: "AQ", code3: "ATA", numCode: "010" },
  { name: "Antigua and Barbuda", code: "AG", code3: "ATG", numCode: "028" },
  { name: "Argentina", code: "AR", code3: "ARG", numCode: "032" },
  { name: "Armenia", code: "AM", code3: "ARM", numCode: "051" },
  { name: "Aruba", code: "AW", code3: "ABW", numCode: "533" },
  { name: "Australia", code: "AU", code3: "AUS", numCode: "036" },
  { name: "Austria", code: "AT", code3: "AUT", numCode: "040" },
  { name: "Azerbaijan", code: "AZ", code3: "AZE", numCode: "031" },
  { name: "Bahamas", code: "BS", code3: "BHS", numCode: "044" },
  { name: "Bahrain", code: "BH", code3: "BHR", numCode: "048" },
  { name: "Bangladesh", code: "BD", code3: "BGD", numCode: "050" },
  { name: "Barbados", code: "BB", code3: "BRB", numCode: "052" },
  { name: "Belarus", code: "BY", code3: "BLR", numCode: "112" },
  { name: "Belgium", code: "BE", code3: "BEL", numCode: "056" },
  { name: "Belize", code: "BZ", code3: "BLZ", numCode: "084" },
  { name: "Benin", code: "BJ", code3: "BEN", numCode: "204" },
  { name: "Bermuda", code: "BM", code3: "BMU", numCode: "060" },
  { name: "Bhutan", code: "BT", code3: "BTN", numCode: "064" },
  { name: "Bolivia", code: "BO", code3: "BOL", numCode: "068" },
  { name: "Bonaire, Sint Eustatius and Saba", code: "BQ", code3: "BES", numCode: "535" },
  { name: "Bosnia and Herzegovina", code: "BA", code3: "BIH", numCode: "070" },
  { name: "Botswana", code: "BW", code3: "BWA", numCode: "072" },
  { name: "Bouvet Island", code: "BV", code3: "BVT", numCode: "074" },
  { name: "Brazil", code: "BR", code3: "BRA", numCode: "076" },
  { name: "British Indian Ocean Territory", code: "IO", code3: "IOT", numCode: "086" },
  { name: "Brunei Darussalam", code: "BN", code3: "BRN", numCode: "096" },
  { name: "Bulgaria", code: "BG", code3: "BGR", numCode: "100" },
  { name: "Burkina Faso", code: "BF", code3: "BFA", numCode: "854" },
  { name: "Burundi", code: "BI", code3: "BDI", numCode: "108" },
  { name: "Cabo Verde", code: "CV", code3: "CPV", numCode: "132" },
  { name: "Cambodia", code: "KH", code3: "KHM", numCode: "116" },
  { name: "Cameroon", code: "CM", code3: "CMR", numCode: "120" },
  { name: "Canada", code: "CA", code3: "CAN", numCode: "124" },
  { name: "Cayman Islands", code: "KY", code3: "CYM", numCode: "136" },
  { name: "Central African Republic", code: "CF", code3: "CAF", numCode: "140" },
  { name: "Chad", code: "TD", code3: "TCD", numCode: "148" },
  { name: "Chile", code: "CL", code3: "CHL", numCode: "152" },
  { name: "China", code: "CN", code3: "CHN", numCode: "156" },
  { name: "Christmas Island", code: "CX", code3: "CXR", numCode: "162" },
  { name: "Cocos (Keeling) Islands", code: "CC", code3: "CCK", numCode: "166" },
  { name: "Colombia", code: "CO", code3: "COL", numCode: "170" },
  { name: "Comoros", code: "KM", code3: "COM", numCode: "174" },
  { name: "Congo, Democratic Republic of the", code: "CD", code3: "COD", numCode: "180" },
  { name: "Congo", code: "CG", code3: "COG", numCode: "178" },
  { name: "Cook Islands", code: "CK", code3: "COK", numCode: "184" },
  { name: "Costa Rica", code: "CR", code3: "CRI", numCode: "188" },
  { name: "Côte d'Ivoire", code: "CI", code3: "CIV", numCode: "384" },
  { name: "Croatia", code: "HR", code3: "HRV", numCode: "191" },
  { name: "Cuba", code: "CU", code3: "CUB", numCode: "192" },
  { name: "Curaçao", code: "CW", code3: "CUW", numCode: "531" },
  { name: "Cyprus", code: "CY", code3: "CYP", numCode: "196" },
  { name: "Czechia", code: "CZ", code3: "CZE", numCode: "203" },
  { name: "Denmark", code: "DK", code3: "DNK", numCode: "208" },
  { name: "Djibouti", code: "DJ", code3: "DJI", numCode: "262" },
  { name: "Dominica", code: "DM", code3: "DMA", numCode: "212" },
  { name: "Dominican Republic", code: "DO", code3: "DOM", numCode: "214" },
  { name: "Ecuador", code: "EC", code3: "ECU", numCode: "218" },
  { name: "Egypt", code: "EG", code3: "EGY", numCode: "818" },
  { name: "El Salvador", code: "SV", code3: "SLV", numCode: "222" },
  { name: "Equatorial Guinea", code: "GQ", code3: "GNQ", numCode: "226" },
  { name: "Eritrea", code: "ER", code3: "ERI", numCode: "232" },
  { name: "Estonia", code: "EE", code3: "EST", numCode: "233" },
  { name: "Eswatini", code: "SZ", code3: "SWZ", numCode: "748" },
  { name: "Ethiopia", code: "ET", code3: "ETH", numCode: "231" },
  { name: "Falkland Islands", code: "FK", code3: "FLK", numCode: "238" },
  { name: "Faroe Islands", code: "FO", code3: "FRO", numCode: "234" },
  { name: "Fiji", code: "FJ", code3: "FJI", numCode: "242" },
  { name: "Finland", code: "FI", code3: "FIN", numCode: "246" },
  { name: "France", code: "FR", code3: "FRA", numCode: "250" },
  { name: "French Guiana", code: "GF", code3: "GUF", numCode: "254" },
  { name: "French Polynesia", code: "PF", code3: "PYF", numCode: "258" },
  { name: "French Southern Territories", code: "TF", code3: "ATF", numCode: "260" },
  { name: "Gabon", code: "GA", code3: "GAB", numCode: "266" },
  { name: "Gambia", code: "GM", code3: "GMB", numCode: "270" },
  { name: "Georgia", code: "GE", code3: "GEO", numCode: "268" },
  { name: "Germany", code: "DE", code3: "DEU", numCode: "276" },
  { name: "Ghana", code: "GH", code3: "GHA", numCode: "288" },
  { name: "Gibraltar", code: "GI", code3: "GIB", numCode: "292" },
  { name: "Greece", code: "GR", code3: "GRC", numCode: "300" },
  { name: "Greenland", code: "GL", code3: "GRL", numCode: "304" },
  { name: "Grenada", code: "GD", code3: "GRD", numCode: "308" },
  { name: "Guadeloupe", code: "GP", code3: "GLP", numCode: "312" },
  { name: "Guam", code: "GU", code3: "GUM", numCode: "316" },
  { name: "Guatemala", code: "GT", code3: "GTM", numCode: "320" },
  { name: "Guernsey", code: "GG", code3: "GGY", numCode: "831" },
  { name: "Guinea", code: "GN", code3: "GIN", numCode: "324" },
  { name: "Guinea-Bissau", code: "GW", code3: "GNB", numCode: "624" },
  { name: "Guyana", code: "GY", code3: "GUY", numCode: "328" },
  { name: "Haiti", code: "HT", code3: "HTI", numCode: "332" },
  { name: "Heard Island and McDonald Islands", code: "HM", code3: "HMD", numCode: "334" },
  { name: "Holy See", code: "VA", code3: "VAT", numCode: "336" },
  { name: "Honduras", code: "HN", code3: "HND", numCode: "340" },
  { name: "Hong Kong", code: "HK", code3: "HKG", numCode: "344" },
  { name: "Hungary", code: "HU", code3: "HUN", numCode: "348" },
  { name: "Iceland", code: "IS", code3: "ISL", numCode: "352" },
  { name: "India", code: "IN", code3: "IND", numCode: "356" },
  { name: "Indonesia", code: "ID", code3: "IDN", numCode: "360" },
  { name: "Iran", code: "IR", code3: "IRN", numCode: "364" },
  { name: "Iraq", code: "IQ", code3: "IRQ", numCode: "368" },
  { name: "Ireland", code: "IE", code3: "IRL", numCode: "372" },
  { name: "Isle of Man", code: "IM", code3: "IMN", numCode: "833" },
  { name: "Israel", code: "IL", code3: "ISR", numCode: "376" },
  { name: "Italy", code: "IT", code3: "ITA", numCode: "380" },
  { name: "Jamaica", code: "JM", code3: "JAM", numCode: "388" },
  { name: "Japan", code: "JP", code3: "JPN", numCode: "392" },
  { name: "Jersey", code: "JE", code3: "JEY", numCode: "832" },
  { name: "Jordan", code: "JO", code3: "JOR", numCode: "400" },
  { name: "Kazakhstan", code: "KZ", code3: "KAZ", numCode: "398" },
  { name: "Kenya", code: "KE", code3: "KEN", numCode: "404" },
  { name: "Kiribati", code: "KI", code3: "KIR", numCode: "296" },
  { name: "Korea, Democratic People's Republic of", code: "KP", code3: "PRK", numCode: "408" },
  { name: "Korea, Republic of", code: "KR", code3: "KOR", numCode: "410" },
  { name: "Kuwait", code: "KW", code3: "KWT", numCode: "414" },
  { name: "Kyrgyzstan", code: "KG", code3: "KGZ", numCode: "417" },
  { name: "Lao People's Democratic Republic", code: "LA", code3: "LAO", numCode: "418" },
  { name: "Latvia", code: "LV", code3: "LVA", numCode: "428" },
  { name: "Lebanon", code: "LB", code3: "LBN", numCode: "422" },
  { name: "Lesotho", code: "LS", code3: "LSO", numCode: "426" },
  { name: "Liberia", code: "LR", code3: "LBR", numCode: "430" },
  { name: "Libya", code: "LY", code3: "LBY", numCode: "434" },
  { name: "Liechtenstein", code: "LI", code3: "LIE", numCode: "438" },
  { name: "Lithuania", code: "LT", code3: "LTU", numCode: "440" },
  { name: "Luxembourg", code: "LU", code3: "LUX", numCode: "442" },
  { name: "Macao", code: "MO", code3: "MAC", numCode: "446" },
  { name: "Madagascar", code: "MG", code3: "MDG", numCode: "450" },
  { name: "Malawi", code: "MW", code3: "MWI", numCode: "454" },
  { name: "Malaysia", code: "MY", code3: "MYS", numCode: "458" },
  { name: "Maldives", code: "MV", code3: "MDV", numCode: "462" },
  { name: "Mali", code: "ML", code3: "MLI", numCode: "466" },
  { name: "Malta", code: "MT", code3: "MLT", numCode: "470" },
  { name: "Marshall Islands", code: "MH", code3: "MHL", numCode: "584" },
  { name: "Martinique", code: "MQ", code3: "MTQ", numCode: "474" },
  { name: "Mauritania", code: "MR", code3: "MRT", numCode: "478" },
  { name: "Mauritius", code: "MU", code3: "MUS", numCode: "480" },
  { name: "Mayotte", code: "YT", code3: "MYT", numCode: "175" },
  { name: "Mexico", code: "MX", code3: "MEX", numCode: "484" },
  { name: "Micronesia", code: "FM", code3: "FSM", numCode: "583" },
  { name: "Moldova", code: "MD", code3: "MDA", numCode: "498" },
  { name: "Monaco", code: "MC", code3: "MCO", numCode: "492" },
  { name: "Mongolia", code: "MN", code3: "MNG", numCode: "496" },
  { name: "Montenegro", code: "ME", code3: "MNE", numCode: "499" },
  { name: "Montserrat", code: "MS", code3: "MSR", numCode: "500" },
  { name: "Morocco", code: "MA", code3: "MAR", numCode: "504" },
  { name: "Mozambique", code: "MZ", code3: "MOZ", numCode: "508" },
  { name: "Myanmar", code: "MM", code3: "MMR", numCode: "104" },
  { name: "Namibia", code: "NA", code3: "NAM", numCode: "516" },
  { name: "Nauru", code: "NR", code3: "NRU", numCode: "520" },
  { name: "Nepal", code: "NP", code3: "NPL", numCode: "524" },
  { name: "Netherlands", code: "NL", code3: "NLD", numCode: "528" },
  { name: "New Caledonia", code: "NC", code3: "NCL", numCode: "540" },
  { name: "New Zealand", code: "NZ", code3: "NZL", numCode: "554" },
  { name: "Nicaragua", code: "NI", code3: "NIC", numCode: "558" },
  { name: "Niger", code: "NE", code3: "NER", numCode: "562" },
  { name: "Nigeria", code: "NG", code3: "NGA", numCode: "566" },
  { name: "Niue", code: "NU", code3: "NIU", numCode: "570" },
  { name: "Norfolk Island", code: "NF", code3: "NFK", numCode: "574" },
  { name: "North Macedonia", code: "MK", code3: "MKD", numCode: "807" },
  { name: "Northern Mariana Islands", code: "MP", code3: "MNP", numCode: "580" },
  { name: "Norway", code: "NO", code3: "NOR", numCode: "578" },
  { name: "Oman", code: "OM", code3: "OMN", numCode: "512" },
  { name: "Pakistan", code: "PK", code3: "PAK", numCode: "586" },
  { name: "Palau", code: "PW", code3: "PLW", numCode: "585" },
  { name: "Palestine, State of", code: "PS", code3: "PSE", numCode: "275" },
  { name: "Panama", code: "PA", code3: "PAN", numCode: "591" },
  { name: "Papua New Guinea", code: "PG", code3: "PNG", numCode: "598" },
  { name: "Paraguay", code: "PY", code3: "PRY", numCode: "600" },
  { name: "Peru", code: "PE", code3: "PER", numCode: "604" },
  { name: "Philippines", code: "PH", code3: "PHL", numCode: "608" },
  { name: "Pitcairn", code: "PN", code3: "PCN", numCode: "612" },
  { name: "Poland", code: "PL", code3: "POL", numCode: "616" },
  { name: "Portugal", code: "PT", code3: "PRT", numCode: "620" },
  { name: "Puerto Rico", code: "PR", code3: "PRI", numCode: "630" },
  { name: "Qatar", code: "QA", code3: "QAT", numCode: "634" },
  { name: "Réunion", code: "RE", code3: "REU", numCode: "638" },
  { name: "Romania", code: "RO", code3: "ROU", numCode: "642" },
  { name: "Russian Federation", code: "RU", code3: "RUS", numCode: "643" },
  { name: "Rwanda", code: "RW", code3: "RWA", numCode: "646" },
  { name: "Saint Barthélemy", code: "BL", code3: "BLM", numCode: "652" },
  { name: "Saint Helena, Ascension and Tristan da Cunha", code: "SH", code3: "SHN", numCode: "654" },
  { name: "Saint Kitts and Nevis", code: "KN", code3: "KNA", numCode: "659" },
  { name: "Saint Lucia", code: "LC", code3: "LCA", numCode: "662" },
  { name: "Saint Martin (French part)", code: "MF", code3: "MAF", numCode: "663" },
  { name: "Saint Pierre and Miquelon", code: "PM", code3: "SPM", numCode: "666" },
  { name: "Saint Vincent and the Grenadines", code: "VC", code3: "VCT", numCode: "670" },
  { name: "Samoa", code: "WS", code3: "WSM", numCode: "882" },
  { name: "San Marino", code: "SM", code3: "SMR", numCode: "674" },
  { name: "Sao Tome and Principe", code: "ST", code3: "STP", numCode: "678" },
  { name: "Saudi Arabia", code: "SA", code3: "SAU", numCode: "682" },
  { name: "Senegal", code: "SN", code3: "SEN", numCode: "686" },
  { name: "Serbia", code: "RS", code3: "SRB", numCode: "688" },
  { name: "Seychelles", code: "SC", code3: "SYC", numCode: "690" },
  { name: "Sierra Leone", code: "SL", code3: "SLE", numCode: "694" },
  { name: "Singapore", code: "SG", code3: "SGP", numCode: "702" },
  { name: "Sint Maarten (Dutch part)", code: "SX", code3: "SXM", numCode: "534" },
  { name: "Slovakia", code: "SK", code3: "SVK", numCode: "703" },
  { name: "Slovenia", code: "SI", code3: "SVN", numCode: "705" },
  { name: "Solomon Islands", code: "SB", code3: "SLB", numCode: "090" },
  { name: "Somalia", code: "SO", code3: "SOM", numCode: "706" },
  { name: "South Africa", code: "ZA", code3: "ZAF", numCode: "710" },
  { name: "South Georgia and the South Sandwich Islands", code: "GS", code3: "SGS", numCode: "239" },
  { name: "South Sudan", code: "SS", code3: "SSD", numCode: "728" },
  { name: "Spain", code: "ES", code3: "ESP", numCode: "724" },
  { name: "Sri Lanka", code: "LK", code3: "LKA", numCode: "144" },
  { name: "Sudan", code: "SD", code3: "SDN", numCode: "729" },
  { name: "Suriname", code: "SR", code3: "SUR", numCode: "740" },
  { name: "Svalbard and Jan Mayen", code: "SJ", code3: "SJM", numCode: "744" },
  { name: "Sweden", code: "SE", code3: "SWE", numCode: "752" },
  { name: "Switzerland", code: "CH", code3: "CHE", numCode: "756" },
  { name: "Syrian Arab Republic", code: "SY", code3: "SYR", numCode: "760" },
  { name: "Taiwan, Province of China", code: "TW", code3: "TWN", numCode: "158" },
  { name: "Tajikistan", code: "TJ", code3: "TJK", numCode: "762" },
  { name: "Tanzania, United Republic of", code: "TZ", code3: "TZA", numCode: "834" },
  { name: "Thailand", code: "TH", code3: "THA", numCode: "764" },
  { name: "Timor-Leste", code: "TL", code3: "TLS", numCode: "626" },
  { name: "Togo", code: "TG", code3: "TGO", numCode: "768" },
  { name: "Tokelau", code: "TK", code3: "TKL", numCode: "772" },
  { name: "Tonga", code: "TO", code3: "TON", numCode: "776" },
  { name: "Trinidad and Tobago", code: "TT", code3: "TTO", numCode: "780" },
  { name: "Tunisia", code: "TN", code3: "TUN", numCode: "788" },
  { name: "Türkiye", code: "TR", code3: "TUR", numCode: "792" },
  { name: "Turkmenistan", code: "TM", code3: "TKM", numCode: "795" },
  { name: "Turks and Caicos Islands", code: "TC", code3: "TCA", numCode: "796" },
  { name: "Tuvalu", code: "TV", code3: "TUV", numCode: "798" },
  { name: "Uganda", code: "UG", code3: "UGA", numCode: "800" },
  { name: "Ukraine", code: "UA", code3: "UKR", numCode: "804" },
  { name: "United Arab Emirates", code: "AE", code3: "ARE", numCode: "784" },
  { name: "United Kingdom", code: "GB", code3: "GBR", numCode: "826" },
  { name: "United States Minor Outlying Islands", code: "UM", code3: "UMI", numCode: "581" },
  { name: "United States of America", code: "US", code3: "USA", numCode: "840" },
  { name: "Uruguay", code: "UY", code3: "URY", numCode: "858" },
  { name: "Uzbekistan", code: "UZ", code3: "UZB", numCode: "860" },
  { name: "Vanuatu", code: "VU", code3: "VUT", numCode: "548" },
  { name: "Venezuela", code: "VE", code3: "VEN", numCode: "862" },
  { name: "Viet Nam", code: "VN", code3: "VNM", numCode: "704" },
  { name: "Virgin Islands (British)", code: "VG", code3: "VGB", numCode: "092" },
  { name: "Virgin Islands (U.S.)", code: "VI", code3: "VIR", numCode: "850" },
  { name: "Wallis and Futuna", code: "WF", code3: "WLF", numCode: "876" },
  { name: "Western Sahara", code: "EH", code3: "ESH", numCode: "732" },
  { name: "Yemen", code: "YE", code3: "YEM", numCode: "887" },
  { name: "Zambia", code: "ZM", code3: "ZMB", numCode: "894" },
  { name: "Zimbabwe", code: "ZW", code3: "ZWE", numCode: "716" }
];

export const state: StateData[] = [
  {
    "name": "Alabama",
    "stateCode": "AL",
    "countryCode": "US"
  },
  {
    "name": "Alaska",
    "stateCode": "AK",
    "countryCode": "US"
  },
  {
    "name": "Arizona",
    "stateCode": "AZ",
    "countryCode": "US"
  },
  {
    "name": "Arkansas",
    "stateCode": "AR",
    "countryCode": "US"
  },
  {
    "name": "California",
    "stateCode": "CA",
    "countryCode": "US"
  },
  {
    "name": "Colorado",
    "stateCode": "CO",
    "countryCode": "US"
  },
  {
    "name": "Connecticut",
    "stateCode": "CT",
    "countryCode": "US"
  },
  {
    "name": "Delaware",
    "stateCode": "DE",
    "countryCode": "US"
  },
  {
    "name": "Florida",
    "stateCode": "FL",
    "countryCode": "US"
  },
  {
    "name": "Georgia",
    "stateCode": "GA",
    "countryCode": "US"
  },
  {
    "name": "Hawaii",
    "stateCode": "HI",
    "countryCode": "US"
  },
  {
    "name": "Idaho",
    "stateCode": "ID",
    "countryCode": "US"
  },
  {
    "name": "Illinois",
    "stateCode": "IL",
    "countryCode": "US"
  },
  {
    "name": "Indiana",
    "stateCode": "IN",
    "countryCode": "US"
  },
  {
    "name": "Iowa",
    "stateCode": "IA",
    "countryCode": "US"
  },
  {
    "name": "Kansas",
    "stateCode": "KS",
    "countryCode": "US"
  },
  {
    "name": "Kentucky",
    "stateCode": "KY",
    "countryCode": "US"
  },
  {
    "name": "Louisiana",
    "stateCode": "LA",
    "countryCode": "US"
  },
  {
    "name": "Maine",
    "stateCode": "ME",
    "countryCode": "US"
  },
  {
    "name": "Maryland",
    "stateCode": "MD",
    "countryCode": "US"
  },
  {
    "name": "Massachusetts",
    "stateCode": "MA",
    "countryCode": "US"
  },
  {
    "name": "Michigan",
    "stateCode": "MI",
    "countryCode": "US"
  },
  {
    "name": "Minnesota",
    "stateCode": "MN",
    "countryCode": "US"
  },
  {
    "name": "Mississippi",
    "stateCode": "MS",
    "countryCode": "US"
  },
  {
    "name": "Missouri",
    "stateCode": "MO",
    "countryCode": "US"
  },
  {
    "name": "Montana",
    "stateCode": "MT",
    "countryCode": "US"
  },
  {
    "name": "Nebraska",
    "stateCode": "NE",
    "countryCode": "US"
  },
  {
    "name": "Nevada",
    "stateCode": "NV",
    "countryCode": "US"
  },
  {
    "name": "New Hampshire",
    "stateCode": "NH",
    "countryCode": "US"
  },
  {
    "name": "New Jersey",
    "stateCode": "NJ",
    "countryCode": "US"
  },
  {
    "name": "New Mexico",
    "stateCode": "NM",
    "countryCode": "US"
  },
  {
    "name": "New York",
    "stateCode": "NY",
    "countryCode": "US"
  },
  {
    "name": "North Carolina",
    "stateCode": "NC",
    "countryCode": "US"
  },
  {
    "name": "North Dakota",
    "stateCode": "ND",
    "countryCode": "US"
  },
  {
    "name": "Ohio",
    "stateCode": "OH",
    "countryCode": "US"
  },
  {
    "name": "Oklahoma",
    "stateCode": "OK",
    "countryCode": "US"
  },
  {
    "name": "Oregon",
    "stateCode": "OR",
    "countryCode": "US"
  },
  {
    "name": "Pennsylvania",
    "stateCode": "PA",
    "countryCode": "US"
  },
  {
    "name": "Rhode Island",
    "stateCode": "RI",
    "countryCode": "US"
  },
  {
    "name": "South Carolina",
    "stateCode": "SC",
    "countryCode": "US"
  },
  {
    "name": "South Dakota",
    "stateCode": "SD",
    "countryCode": "US"
  },
  {
    "name": "Tennessee",
    "stateCode": "TN",
    "countryCode": "US"
  },
  {
    "name": "Texas",
    "stateCode": "TX",
    "countryCode": "US"
  },
  {
    "name": "Utah",
    "stateCode": "UT",
    "countryCode": "US"
  },
  {
    "name": "Vermont",
    "stateCode": "VT",
    "countryCode": "US"
  },
  {
    "name": "Virginia",
    "stateCode": "VA",
    "countryCode": "US"
  },
  {
    "name": "Washington",
    "stateCode": "WA",
    "countryCode": "US"
  },
  {
    "name": "West Virginia",
    "stateCode": "WV",
    "countryCode": "US"
  },
  {
    "name": "Wisconsin",
    "stateCode": "WI",
    "countryCode": "US"
  },
  {
    "name": "Wyoming",
    "stateCode": "WY",
    "countryCode": "US"
  }
];

export const province: StateData[] = [
  {
    "name": "Alberta",
    "stateCode": "AB",
    "countryCode": "CA"
  },
  {
    "name": "British Columbia",
    "stateCode": "BC",
    "countryCode": "CA"
  },
  {
    "name": "Manitoba",
    "stateCode": "MB",
    "countryCode": "CA"
  },
  {
    "name": "New Brunswick",
    "stateCode": "NB",
    "countryCode": "CA"
  },
  {
    "name": "Newfoundland and Labrador",
    "stateCode": "NL",
    "countryCode": "CA"
  },
  {
    "name": "Northwest Territories",
    "stateCode": "NT",
    "countryCode": "CA"
  },
  {
    "name": "Nova Scotia",
    "stateCode": "NS",
    "countryCode": "CA"
  },
  {
    "name": "Nunavut",
    "stateCode": "NU",
    "countryCode": "CA"
  },
  {
    "name": "Ontario",
    "stateCode": "ON",
    "countryCode": "CA"
  },
  {
    "name": "Prince Edward Island",
    "stateCode": "PE",
    "countryCode": "CA"
  },
  {
    "name": "Quebec",
    "stateCode": "QC",
    "countryCode": "CA"
  },
  {
    "name": "Saskatchewan",
    "stateCode": "SK",
    "countryCode": "CA"
  },
  {
    "name": "Yukon Territory",
    "stateCode": "YT",
    "countryCode": "CA"
  }
];

// Top countries that should appear first in dropdown lists
export const topCountries = [
  "US", "CA", "GB", "BR", "AU"
];

// Helper function to sort countries with top countries first
export const getCountriesForDropdown = () => {
  const topCountriesList = countries.filter(country =>
    topCountries.includes(country.code)
  );

  const otherCountries = countries.filter(country =>
    !topCountries.includes(country.code)
  ).sort((a, b) => a.name.localeCompare(b.name));

  return [...topCountriesList, ...otherCountries];
};
